import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';

// Components
import { WpModal, WpModalHeader, WpModalBody, WpModalFooter } from 'Wpds/components/modal';
import { WpButtonGroup, WpButton } from 'Wpds/components/button';
import { WpForm, WpFormLayout } from 'Wpds/components/form';
import { VisuallyHidden } from 'Wpds/components/visually-hidden/VisuallyHidden';
import WpTextField from 'Wpds/components/text-field/WpTextField';

type Props = {
  isOpen?: boolean;
  toggleIsOpen?: () => void;
};

const ConnectMetaWorkplaceModal = ({ isOpen, toggleIsOpen }: Props) => {
  const btnRef = useRef(null);

  const metaWorkplaceNotificationDestination = useSelector(state =>
    state.notification_destinations.find(({ slug }) => slug === 'meta_workplace')
  );

  const handleSubmitClick = () => {
    btnRef.current.click();
  };

  const csrfValue = get(document.getElementsByName('csrf-token')[0], 'content');
  return (
    <WpModal isOpen={isOpen} size="sm" onToggle={toggleIsOpen}>
      <WpModalHeader>Enter Meta Workplace Information</WpModalHeader>
      <WpModalBody>
        <WpForm method="post" action={metaWorkplaceNotificationDestination.path}>
          <WpFormLayout>
            <WpTextField id="application_id" name="application_id" label="Application ID" required />
            <WpTextField id="application_secret" name="application_secret" label="Application Secret" required />
            <WpTextField
              id="application_access_token"
              name="application_access_token"
              label="Application Access Token"
              required
            />
            <WpTextField id="subdomain" name="subdomain" label="Subdomain" required />
            <div style={{ visibility: 'hidden', height: '0px', position: 'absolute', top: '-1000px', left: '-1000px' }}>
              <WpTextField type="text" id="authenticity_token" label="authenticity_token" value={csrfValue} readOnly />
            </div>
            <VisuallyHidden>
              <WpButton btnType="submit" ref={btnRef}>
                submit
              </WpButton>
            </VisuallyHidden>
          </WpFormLayout>
        </WpForm>
      </WpModalBody>
      <WpModalFooter>
        <WpButtonGroup>
          <WpButton variant="tertiary" onClick={toggleIsOpen}>
            Cancel
          </WpButton>
          <WpButton onClick={handleSubmitClick}>Save</WpButton>
        </WpButtonGroup>
      </WpModalFooter>
    </WpModal>
  );
};

export default ConnectMetaWorkplaceModal;
